import React from "react";
import { Page, LegacyCard, Text, BlockStack, InlineGrid } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";
import AppWrapper from "../AppWrapper";
import { REPORTS, CATEGORY_ORDER } from "./registry";

function Reports() {
  const navigate = useNavigate();

  // Group reports by category, preserving the configured order.
  const byCategory = REPORTS.reduce((acc, r) => {
    (acc[r.category] = acc[r.category] || []).push(r);
    return acc;
  }, {});
  const categories = [
    ...CATEGORY_ORDER.filter((c) => byCategory[c]),
    ...Object.keys(byCategory).filter((c) => !CATEGORY_ORDER.includes(c)),
  ];

  return (
    <AppWrapper>
      <Page title="Reportes">
        <BlockStack gap="400">
          {categories.length === 0 ? (
            <LegacyCard sectioned>
              <Text tone="subdued">No hay reportes disponibles aún.</Text>
            </LegacyCard>
          ) : (
            categories.map((cat) => (
              <div key={cat}>
                <div style={{ marginBottom: 8 }}>
                  <Text variant="headingMd">{cat}</Text>
                </div>
                <InlineGrid columns={{ xs: 1, sm: 2, md: 3 }} gap="300">
                  {byCategory[cat].map((r) => (
                    <LegacyCard key={r.id} sectioned>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate(`/reports/${r.id}`)}
                      >
                        <Text variant="headingSm">{r.title}</Text>
                        <Text variant="bodySm" tone="subdued">
                          {r.description}
                        </Text>
                      </div>
                    </LegacyCard>
                  ))}
                </InlineGrid>
              </div>
            ))
          )}
        </BlockStack>
      </Page>
    </AppWrapper>
  );
}

export default Reports;
